import { HarmonyDefaultThemeId } from '@office-start/theming-types';
export var isHarmonyThemeId = (function () {
    var harmonyThemeIdsLower = HarmonyDefaultThemeId.map(function (id) {
        return id.toLowerCase();
    });
    return function (themeId) {
        if (!themeId) {
            return false;
        }
        return harmonyThemeIdsLower.includes(themeId.toLowerCase());
    };
})();
//# sourceMappingURL=isHarmonyThemeId.js.map